import React from 'react'
import {Users} from './components/Users'
import {Route, Routes} from 'react-router-dom'

export const UserPage: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path='/' element={<Users className='mb-5 mb-xl-8' />} />
      </Routes>
    </>
  )
}
